import React from "react";

export const new_game = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <g id="g3796-8" transform="translate(-15.073 -5.356)">
            <path
                id="path4361"
                d="M20.854,29.325c-3.446-.11-5.564-.29-5.724-.487a1.645,1.645,0,0,1,.109-1.1c.445-.987,1.454-2.016,3.9-3.98.813-.652,1.684-1.387,1.936-1.632a7.207,7.207,0,0,0,1.683-2.381c.186-.437,1.118-3.039,1.118-3.122a10.862,10.862,0,0,0-1.458-.116,15.857,15.857,0,0,1-3.667-.368,19.5,19.5,0,0,1,3.225-2.467L23.6,12.558l-.625-.992a4.24,4.24,0,0,1-.9-2.136,2.211,2.211,0,0,1,.373-1.472,6.432,6.432,0,0,1,3.524-2.45,4.114,4.114,0,0,1,2.767.2A6.408,6.408,0,0,1,31.8,8.189a2.757,2.757,0,0,1,0,2.225,11.7,11.7,0,0,1-.706,1.215,7.642,7.642,0,0,0-.551.927c.011.023.776.562,1.7,1.2a24.529,24.529,0,0,1,3.124,2.367c0,.055-.333.123-1.077.22-.2.026-1.168.087-2.148.135s-1.815.1-1.857.1a21.889,21.889,0,0,0,1.056,3.143A7.512,7.512,0,0,0,33.2,22.283c.2.188.8.685,1.319,1.1a24.1,24.1,0,0,1,3.6,3.22c.807.945,1.178,1.96.819,2.24a17.444,17.444,0,0,1-4.14.43c-1.49.072-12.052.108-13.941.048Z"
            />
        </g>
    </svg>
);
